<template>
  <div class="container-fluid mt-5">
    <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
      <template slot="header">
        <h3 class="mb-0">
          <i class="fa fa-graduation-cap text-primary mr-2"></i>
          {{ $t("TRAININGS.TRAININGS") }}
        </h3>
      </template>

      <div class="col-12">
        <tabs
          fill
          class="flex-column flex-md-row"
          tabNavWrapperClasses="nav-wrapper"
          tabNavClasses="nav nav-pills nav-fill"
          :value="activeTab"
        >
          <card shadow>
            <tab-pane title="all" id="1">
              <span slot="title">
                <i class="fa fa-play-circle" />
                {{ $t("TRAININGS.TAB_ALL") }}
              </span>
              <training-all-topics />
            </tab-pane>

            <tab-pane title="path" id="2">
              <span slot="title">
                <i class="fa fa-route" />
                {{ $t("TRAININGS.TAB_MY_PATH") }}
              </span>
              <training-my-path />
            </tab-pane>

            <tab-pane v-if="canManage" title="help" id="3">
              <span slot="title">
                <i class="fa fa-question-circle" />
                {{ $t("TRAININGS.TAB_HELP_LINKS") }}
              </span>
              <training-help-links />
            </tab-pane>

            <tab-pane v-if="canManage" title="paths" id="4">
              <span slot="title">
                <i class="fa fa-list-ol" />
                {{ $t("TRAININGS.TAB_PATHS") }}
              </span>
              <training-role-paths />
            </tab-pane>

            <tab-pane v-if="canManage" title="follow-up" id="5">
              <span slot="title">
                <i class="fa fa-user-check" />
                {{ $t("TRAININGS.TAB_FOLLOW_UP") }}
              </span>
              <training-follow-up />
            </tab-pane>
          </card>
        </tabs>
      </div>
    </card>
  </div>
</template>

<script>
import { Tabs, TabPane } from "@/components";
import TrainingAllTopics from "./partials/TrainingAllTopics.vue";
import TrainingMyPath from "./partials/TrainingMyPath.vue";
import TrainingHelpLinks from "./partials/TrainingHelpLinks.vue";
import TrainingRolePaths from "./partials/TrainingRolePaths.vue";
import TrainingFollowUp from "./partials/TrainingFollowUp.vue";

export default {
  layout: "DashboardLayout",

  components: {
    Tabs,
    TabPane,
    TrainingAllTopics,
    TrainingMyPath,
    TrainingHelpLinks,
    TrainingRolePaths,
    TrainingFollowUp,
  },

  computed: {
    canManage() {
      return this.$currentUserCan(this.$permissions.PERM_MANAGE_TRAININGS);
    },
    activeTab() {
      return this.$route.query.tab || "all";
    },
  },
};
</script>
